import { render } from "./MobileMenuBlocker.vue?vue&type=template&id=55184541"
import script from "./MobileMenuBlocker.vue?vue&type=script&lang=js"
export * from "./MobileMenuBlocker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__